import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceBoardSvgComponent } from './price-board-svg.component';

@NgModule({
  declarations: [
    PriceBoardSvgComponent
  ],
  imports: [
    CommonModule
  ], exports:[
    PriceBoardSvgComponent
  ]
})
export class PriceBoardSvgModule { }
